<template>
  <v-flex class="pl-1">

    <span v-if="selectedClient.name && (advertisers.length === 1)">
      {{selectedClient.name}}
    </span>

    <v-select
      v-if="advertisers.length > 1"
      v-model="advertiser"
      :items="advertisers"
      item-text="data.name"
      item-value="id"
      style = "font-size: 20px"
      class = "mt-2"
    />
  </v-flex>
</template>

<script>
  import lodash from 'lodash'
  import setupChecklistItems from '../../../static/setup-checklist-items'

  export default {
    name: 'header-advertisers-selector',
    data () {
      return {
        advertiser: null
      }
    },
    computed: {
      selectedClient () {
        const user = this.$store.getters.getCurrentUser
        if (!user || !user.firebaseAccount) return {political: {}}
        const selectedAdvertiser = user.firebaseAccount.selectedAdvertiser
        const advertiser = this.$store.getters.getAdvertisers.find(a => a.id === selectedAdvertiser)
        // Note: add missed data in current advertiser
        if (advertiser && !advertiser.data.setupMode) {
          const copy = lodash.cloneDeep(advertiser)
          copy.data.setupMode = {
            items: setupChecklistItems,
            status: true
          }
          this.$store.dispatch('updateAdvertiser', copy)
        }
        if (advertiser) return advertiser.data
        return {political: {}}
      },
      user () {
        return this.$store.getters.getCurrentUser
      },
      advertisers () {
        if (!this.user || !this.user.firebaseAccount.advertisers) return []
        return this.$store.getters.getAdvertisers.filter(a => this.user.firebaseAccount.advertisers.find(ac => ac.id === a.id))
      },
      selectedAdvertiser () {
        return this.advertisers.find(a => a.id === this.user.firebaseAccount.selectedAdvertiser)
      }
    },
    methods: {
      checkCurrentAdvertiser (advertiser) {
        if (!this.user) return false
        return (this.user.firebaseAccount.selectedAdvertiser === advertiser)
      }
    },
    watch: {
      selectedAdvertiser: {
        handler (val) {
          if (val) {
            this.advertiser = val.id
          }
        },
        immediate: true
      },
      advertiser (val) {
        if (!this.user) return false
        if (!this.checkCurrentAdvertiser(val)) {
          let userCopy = lodash.cloneDeep(this.user.firebaseAccount)
          userCopy.selectedAdvertiser = val
          new Promise(resolve => {
            resolve(this.$store.dispatch('updateUser', userCopy))
          })
            .then(res => {
              this.$store.dispatch('startSpinner')
              this.$store.dispatch('showNotification', {
                type: 'success',
                message: [`<div>You updated your account successfully</div>`]
              })
              this.$store.dispatch('stopSpinner')
            })
        }
      }
    }
  }
</script>
